import React, { Component } from 'react'
import { Form, Input, Select } from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { saveProfile } from '../../redux/actions/profileActions'

const { Option } = Select;

export class ContactInfoForm extends Component {
  constructor(props){
    super(props);
      this.state={
        name: '',
        adress: '',
        phone: '',
        houseNum: '', 
        regio: ''
      }    
  }

  componentDidMount=()=>{
    const { profile } = this.props  
    this.setState({
      name: profile.name,
      adress: profile.adress,
      phone: profile.phone,
      houseNum: profile.houseNum,
      regio: profile.regio
    })
  }

  componentDidUpdate=(prevProps)=>{
    const { hasProfile, profile, displayName } = this.props
    if(this.props !== prevProps){
      if(hasProfile && profile.name){
        this.setState({
          name: profile.name,
          adress: profile.adress,
          phone: profile.phone,
          houseNum: profile.houseNum,
          regio: profile.regio
        })
      } else if(!hasProfile && displayName){
        this.setState({
          name: displayName
        })
      } 
    }
  }

  handleChange=(e)=>{
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSelectRegio=(value)=>{
    this.setState({
      regio: value
    })
  }

  handleSave=()=>{
    const { uid, email } = this.props.user
    this.props.saveProfile(uid, email, this.state, this.props.history)
  }
  
  render() {
    const { email } = this.props.user
    const { name, adress, phone, houseNum, regio } = this.state
    const gebieden = [
      <Option key="PBM">Paramaribo</Option>,
      <Option key="CM">Commewijne</Option>,
      <Option key="WN">Wanica</Option>,
      <Option key="PR">Para</Option>,
      <Option key="BR">Brokopondo</Option>,
      <Option key="OO">Andere</Option>,      
    ];
    return (
      <div className="contact-form">
        <h2>Contact Informatie</h2>
        <Form
          layout="vertical"
        >

          <Form.Item label="Naam">
            <Input name='name' onChange={this.handleChange} value={name}/>
          </Form.Item>
          
          <Form.Item label="Adres">
            <Input name='adress' onChange={this.handleChange} value={adress}/>
          </Form.Item>
          
          <Form.Item label="Huisnummer">
            <Input name='houseNum' onChange={this.handleChange} value={houseNum}/>
          </Form.Item>
          
          <Form.Item label="Buurt">
          <Select
              placeholder="Selecteer uw buurt"
              onChange={this.handleSelectRegio}
              value={regio}
            >
              {gebieden}
            </Select>
          </Form.Item>
          
          <Form.Item label="Contact nummer">
            <Input name='phone' onChange={this.handleChange} value={phone}/>
          </Form.Item>
          
          <Form.Item label="Email">
            <Input value={email} disabled />
          </Form.Item>

          <button className="med-main-btn" onClick={this.handleSave}>Opslaan</button>

        </Form>
      </div>
    )
  }
}

export default connect(null, { saveProfile })(withRouter(ContactInfoForm))
